import React from 'react';
import PropTypes from 'prop-types';

import {
  getUniqueSeatIdsFromListing,
  getListingIdFromListing,
  getListingFromSectionRowSeatIds,
  getsCoordsOfAGroupOfSeats,
  tapArea,
} from './helper-functions/mapbox_helpers';
import {getDefaultQuantityBasedOnListing} from './listing-helper';
import {LAYER_ROWS_ID, LAYER_SEATS_HIGHLIGHTED_ID} from './mapbox-constants/mapbox_constants';
import SeatMapToolTip from './seatMapToolTip.js';

export default class SeatMapRowsAndSeats extends React.Component {
  constructor(props) {
    super(props);
    const {mapConfigData} = this.props;
    this.tapPaddingWidth = mapConfigData.CLICK_PADDING_WIDTH;
    this.tapPaddingHeight = mapConfigData.CLICK_PADDING_HEIGHT;

    this.state = {
      rowCenteredOnMap: false,
      seatClickedFromMap: false,
      sectionClicked: false,
      GASectionIdClickedFromList: null,
    };
  }

  // TODO: this function is used to filter listing of selected rows.
  // eslint-disable-next-line react/no-unused-class-component-methods
  handleRowClick = (e) => {
    if (this.rowTooltip.isOpen()) {
      this.rowTooltip.remove();
    }
    const {updateQuery, listingRows, sectionIdList, mapConfigData, availableRows} = this.props;

    const {mapInstance} = this.rowAndSeatActions;

    const {centerOnFeature} = this.rowAndSeatActions.actions;

    const rowFeatures = mapInstance.queryRenderedFeatures(
      tapArea(e.point, this.tapPaddingWidth, this.tapPaddingHeight),
      {layers: [LAYER_ROWS_ID], filter: ['in', 'urid', ...availableRows]}
    );

    if (Array.isArray(rowFeatures) && rowFeatures.length > 0) {
      const [firstFeature] = rowFeatures;
      if (firstFeature && firstFeature.properties && firstFeature.properties.urid) {
        const {urid} = firstFeature.properties;
        const [section, row] = urid.split('-');
        const selectedRowFeatures = this.rowFeaturesCache[urid] ? this.rowFeaturesCache[urid] : firstFeature;

        const queryConfig = {
          listingRows: false,
          sectionIdList: false,
          showBYO: false,
          listingId: null,
          byoQuantity: false,
        };

        if (
          String(row) !== String(listingRows) ||
          (String(row) === String(listingRows) && String(sectionIdList) !== String(section))
        ) {
          if (this.rowAndSeatActions.state.rowClickedFromList) {
            const [highlightedSectionId, highlightedRow] = this.rowAndSeatActions.state.rowClickedFromList.split('-');
            if (
              !this.rowAndSeatActions.state.rowCenteredOnMap ||
              String(row) !== highlightedRow ||
              String(section) !== highlightedSectionId
            ) {
              centerOnFeature(selectedRowFeatures);
            }
          } else {
            centerOnFeature(selectedRowFeatures);
          }
          queryConfig.listingRows = row;
          queryConfig.sectionIdList = section;

          this.setState({
            rowCenteredOnMap: true,
          });
        } else if (String(row) === String(listingRows) && String(sectionIdList) === String(section)) {
          if (this.rowAndSeatActions.state.rowClickedFromList) {
            if (!this.rowAndSeatActions.state.rowCenteredOnMap) {
              centerOnFeature(selectedRowFeatures);
            }

            delete queryConfig.listingRows;
            delete queryConfig.sectionIdList;

            this.setState({
              rowCenteredOnMap: true,
            });
          } else {
            if (mapInstance.getZoom() > mapConfigData.ZOOM_UNSELECTED_ROWS) {
              mapInstance.zoomTo(mapConfigData.ZOOM_UNSELECTED_ROWS, {duration: 1000});
            }
            updateQuery(queryConfig);
          }
        }
      }
      this.updateRender();
    }
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  handleHighlightedSeatClick = (e) => {
    const {setListingSelected, device, updateQuery, mapConfigData, availableSeats} = this.props;

    const tapPaddingWidth = mapConfigData.CLICK_PADDING_WIDTH;
    const tapPaddingHeight = mapConfigData.CLICK_PADDING_HEIGHT;

    const {
      clickTooltip,
      state,
      actions,
      seatCoordCache,
      NumbersOfListingsVisibleSeatsCache,
      listingsCenterCoordCache,
      showTooltipAtKnownPoint,
      showToolTipAtFeature,
    } = this.rowAndSeatActions;

    const seatsHighlightLayerFeatures = actions.queryRenderedFeatures(
      tapArea(e.point, tapPaddingWidth, tapPaddingHeight),
      {layers: [LAYER_SEATS_HIGHLIGHTED_ID], filter: ['in', 'usid', ...(availableSeats || [])]}
    );
    if (Array.isArray(seatsHighlightLayerFeatures)) {
      const [firstFeature] = seatsHighlightLayerFeatures;

      if (
        firstFeature &&
        ((state.usidsOfListingSelected && !state.usidsOfListingSelected.includes(firstFeature.properties.usid)) ||
          !clickTooltip.isOpen())
      ) {
        this.setState({
          seatClickedFromMap: true,
          sectionClicked: false,
          GASectionIdClickedFromList: null,
        });

        if (clickTooltip.isOpen()) {
          clickTooltip.remove();
        }

        const {usid} = firstFeature.properties;
        const [sectionId, rowId, seatid] = usid.split('-');

        const listing = getListingFromSectionRowSeatIds(sectionId, rowId, seatid, this.props);
        if (listing) {
          setListingSelected(listing);
          if (listing.seats && Array.isArray(listing.seats) && listing.seats[0].listingId) {
            if (device === 'desktop') {
              this.highlightedSeatsQueryUpdate(listing.seats[0].listingId, listing);
            } else if (device === 'phone') {
              updateQuery({
                sectionIdList: false,
              });
            }
          }
          const listingId = getListingIdFromListing(listing);
          const uniqueSeatIdArray = getUniqueSeatIdsFromListing(listing);
          const listingCoords = getsCoordsOfAGroupOfSeats(seatCoordCache, uniqueSeatIdArray);
          const listingCenterCoord =
            NumbersOfListingsVisibleSeatsCache[listingId] &&
            listingCoords.length <= NumbersOfListingsVisibleSeatsCache[listingId]
              ? listingsCenterCoordCache[listingId]
              : null;
          if (listingCenterCoord) {
            showTooltipAtKnownPoint(listingCenterCoord, uniqueSeatIdArray);
          } else {
            showToolTipAtFeature(firstFeature, seatCoordCache, uniqueSeatIdArray);
          }
        }
      }
      this.updateRender();
    }
  };

  highlightedSeatsQueryUpdate = (listingId, listing) => {
    const {quantity = getDefaultQuantityBasedOnListing(listing), updateQuery} = this.props;
    updateQuery(
      {
        listingId,
        byoQuantity: quantity,
        showBYO: true,
        sectionIdList: false,
      },
      true
    );
  };

  render() {
    return (
      <SeatMapToolTip
        {...this.props}
        {...this.state}
        rowAndSeatActions={(actions) => (this.rowAndSeatActions = actions)}
      />
    );
  }
}

SeatMapRowsAndSeats.propTypes = {
  /* The array of available rows. */
  availableRows: PropTypes.array,

  /** The array of available seats. */
  availableSeats: PropTypes.array,

  /** The device type. */
  device: PropTypes.string,

  /** The array of selected rows. */
  listingRows: PropTypes.array,

  /** The map config data. */
  mapConfigData: PropTypes.object,

  /** The quantity of the listing. */
  quantity: PropTypes.number,

  /** The array of selected sections. */
  sectionIdList: PropTypes.array,

  /** The function to set the selected listing. */
  setListingSelected: PropTypes.func,

  /** The function to update the query. */
  updateQuery: PropTypes.func,
};
